/* cnr-base/CnRBase.js  */
class CnR {
    
    webservice_url = "https://apps.chelseaandrachel.com/";
    api_version = "2023-07";
    endpoints = {
        discountPreview:(site,code)=>`${CnR.webservice_url}/${site}/${code}`,
    }
    keyname = "subscriptions-2024-02";
    constructor(opts={}) {
        this.config = {...this.defaults(),...opts};
        this.inject_css()
        
    }
    defaults() {
      return {};
    }
    /* shopify cart functions */
    async getCart(url="/cart.js",extended=false,callback=()=>{}) {
        let cart = {};
        return fetch(url) 
			.then(res=>(extended)?res.text():res.json());
    }
    async updateCart(payload) {
	    return fetch(`/cart/update.js`, {
	      method: 'POST',
	      credentials: 'same-origin',
	      headers: {
	        'Content-Type': 'application/json',
	        'X-Requested-With': 'xmlhttprequest'
	      },
	      body: JSON.stringify(payload)
	    }).then((response) => response.json());
	 }
     async changeCart(payload) {
        return fetch(`/cart/change.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'xmlhttprequest'
            },
            body: JSON.stringify(payload)
          }).then((response) => response.json());
     }
     async addToCart(payload,callback) {
        return window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
     }

     /* graphql functions */
     async graphql(query,params) {
        return fetch(`/api/${this.api_version}/graphql.json`,{
            method:"POST",
            headers:{
              "content-type":"application/json",
              "X-Shopify-Storefront-Access-Token":this.config.graphql_token
              },
              body:JSON.stringify({query:query,variables:params})
            })
            .then(response=>response.json())
    }
    graphql_sync(query,params) {
        let ajax = new XMLHttpRequest();
        ajax.headers = {
            "content-type":"application/json",
            "X-Shopify-Storefront-Access-Token":this.config.graphql_token
        }
        ajax.open("POST",/api/`${this.api_version}/graphql.json`,false)
        ajax.setRequestHeader("Content-Type", "application/json");
        ajax.setRequestHeader("X-Shopify-Storefront-Access-Token", storefront_token);
        ajax.send(JSON.stringify({query:query,params:params}));
        return JSON.parse(ajax.responseText);
    }
    gid2id(gid) {
      return parseInt(gid.split("/").pop())
    }
     
     css() {
        return '';
     }
     inject_css() {
        let css = this.css();
        if (css.length>0) {
            let style = document.createElement("style");
            style.id=this.constructor.name.toLowerCase();
            style.textContent = this.css();
            document.querySelector("head").appendChild(style);
        }
        
     }
}
/* cnr-cart-shipping-motivator/CnRShippingMotivator.js  */
//* Copyright 2021 Chelsea and Rachel Co. ellie@chelseaandrachel.com *//
class CnRShippingMotivator extends CnR {
    defaults() {
		return {
            inject_css:true,
			extended_cart:false,
			context:"sidecart",
			target:".cnr-shipping-motivator-holder",
			shipping_threshold:100,
			shipping_text:"You're $##amount## away from Free Shipping!",
			shipping_met_text:"You've unlocked free shipping!",
			gwp_enabled:false,
			gwp_threshold:150,
			gwp_text:"You're $##amount## away from a free gift",
			gwp_met_text:"You've unlocked free shipping and a free gift!",
			gwp_indicator_text:"Free gift",
			shipping_indicator_text:"",
			bottom_text:"",
			cart_total:0,
			item_applicable_amount:(item)=>item.quantity*item.discounted_price,
	};}
	constructor(opts={}) {
		super(opts);
      
		this.shortfall = this.config.threshold;
		this.cart_total = 0;
		this.perc = 0;
		this.goal_met = false;
		this.mode = "shipping";

		document.addEventListener("CartUpdated",(event)=>{
			this.cart = event.detail;
			this.render();
		});
        document.addEventListener("CartEmpty",(event)=>{
			this.cart = {};
			this.blank();
		});
	}
	motivatorText() {
		return ((this.mode=="shipping")?this.config.shipping_text:this.config.gwp_text).replace("##amount##",this.shortfall.toFixed(2));
	} 
	goalMetText() {
		return (this.mode=="shipping")?this.config.shipping_met_text:this.config.gwp_met_text;
	}
	indicatorText() {
		return (this.mode=="shipping")?this.config.shipping_indicator_text:this.config.gwp_indicator_text;
	}
	calculate() {
			this.cart_total = this.cart.items.reduce(
              (sum,item)=>sum+(this.config.item_applicable_amount(item)/100),
              0
            );
			this.shortfall = this.config.shipping_threshold - this.cart_total;
			if (this.shortfall<=0) {
				if (this.config.gwp_enabled) {
					this.mode="gwp";
					this.shortfall = this.config.gwp_threshold - this.cart_total;
					if (this.shortfall<=0) {
						this.shortfall = 0;
						this.perc = 100;
						this.goal_met = true;
					} else {
							this.perc = (this.cart_total/this.config.gwp_threshold)*100;
							this.goal_met = false;
					}

				} else  {
					this.mode="shipping";
					this.shortfall = 0;
					this.perc = 100;
					this.goal_met = true;
				}
				
			} else {
                this.goal_met = false;
				this.mode="shipping";
				this.perc = (this.cart_total/this.config.shipping_threshold)*100;
			}
	}
    blank() {
      let injection_point = document.querySelector(this.config.target);
	 	if (!injection_point) {
	 		console.error(`Injection target ${this.config.target} does not exist`);
	 	}
        injection_point.innerHTML = "";
    }
	render() {
	 	let injection_point = document.querySelector(this.config.target);
	 	if (!injection_point) {
	 		console.error(`Injection target ${this.config.target} does not exist`);
	 	}
        this.calculate();
    
	 	injection_point.childNodes.forEach(node=>injection_point.removeChild(node));
	 	injection_point.innerHTML = `
	 		<div class="cnr-sm-shipping--message js-cnr-sm-shipping--message">
     		<div class="cnr-sm-shipping-full js-cnr-sm-shipping-full h6${this.goal_met?'':' d-none'}"><strong>${this.goalMetText()}</strong></div>
     		<div class="cnr-sm-shipping-start js-cnr-sm-shipping-start h6${this.goal_met?' d-none':''}">
     			${this.motivatorText()}
      	</div>
      </div>
      <div class="cnr-sm-shipping--meter js-cnr-sm-shipping--meter${this.goal_met?' d-none':''}">
      	<div class="cnr-sm-shipping--meter-fill js-cnr-sm-shipping--meter-fill" style="width: ${this.perc}%;"></div>
      </div>
      <div class="cnr-sm-benefits-bar columns-1 js-cnr-sm-benefits-bar">
   	  	<div class="cnr-sm-benefits-item cnr-sm-benefit-freeshipping">
    	  	<div class="cnr-sm-benefits-bar-point"></div>
     			<span>${this.indicatorText()}</span>
    	  </div>
		  <div class="cnr-sm--bottom-text">${this.config.bottom_text}</div>
      </div>
	 	`;
	}	  
	getCart(cart=null) {
		if (cart!=null) {
			this.cart = cart;
			this.render();
			return;
		}
		fetch(this.config.extended_cart?"/cart?view=json":"/cart.js")
			.then(res=>(this.config.extended_cart)?res.text():res.json())
			.then(cart=>{
				if (this.config.extended_cart) {
					eval(cart);
					this.cart = window.cart;
				} else {
					this.cart = cart;
				}
				this.render();
			});
	}
    css() {
      return `
      .cnr-sm-shipping--message {
        padding: 10px 0;
        text-align: center;
      }
      .cnr-sm-shipping--meter {
        background: #e0af59;
        border-radius: 20px;
        display: block;
        font-weight: bold;
        height: 20px;
        margin: 9px 0;
        padding: 0;
        position: relative;
        width: 90%;
        margin-left:24px;
        margin-right:24px;
      }
      .cnr-sm-shipping--meter-fill {
        background: #391d1f;
        border-radius: 24px;
        color: #391d1f;
        font-size: 12px;
        height: 20px;
        left: 0;
        line-height: 20px;
        overflow: hidden;
        opacity: 1;
        padding: 0 10px;
        position: absolute;
        text-align: right;
        top: 0;
        transition: all 0.5s ease;
      }
      .cnr-sm-benefits-bar {
        display:none;
      }
      `;
    }
}
/* pdp-product-carousel/cnr-pdp-photos.js  */
class CnRPdpPhotos extends CnR {
    defaults() {
        return {
            image_filter:(image,data)=>(image.alt.toLowerCase().includes(data.variantName.toLowerCase()) || image.alt.includes("ALLVAR")) && !image.alt.includes("SWATCH"),
            injection_point:".product-photos",
        }

    }
    constructor(options) {
        super(options);
        this.images=[];
        this.fetch();
        document.addEventListener("VariantUpdated",event=>{
            this.config.selected = event.detail;
	    if (this.config.options) {
	            this.render();
	    }
        });
    }
    fetch(after=null) {
        this.run_query(this.config.product_id,after).then(query=>{
          console.error(query);
          this.config.options = query.data.product.options;
            query.data.product.media.edges.filter(item=>item.node.mediaContentType=="IMAGE").forEach(item => {
              
                this.images.push({
                    id:this.gid2id(item.node.id),
                    src:item.node.image.src,
                    alt:item.node.alt
                })
            });
            if (query.data.product.media.pageInfo.hasNextPage) {
                this.fetch(query.data.product.media.pageInfo.endCursor);
            } else {
                this.render();
            }
        });
    }
    run_query(id,after=null) {
        return this.graphql(`
                query getProduct($id:ID!,$first:Int${after!=null?',$after:String':''}) {
                    product(id:$id) {
                        id
                        options {
                          values
                        }
                        media(first:$first${after!=null?',after:$after':''}) {
                            edges {
                                node {
                                mediaContentType
                                alt
                                id
                                ... on MediaImage {
                                    image {
                                    src: url
                                    }
                                }
                                ... on Video {
                                    sources {
                                    src: url
                                    mimeType
                                    format
                                    height
                                    width
                                    }
                                }
                            }
                        }
                        pageInfo {
                            hasNextPage
                            endCursor
                        }
                    }
                  }
                }
                `,
                {id:`gid://shopify/Product/${id}`,after:after,first:250}
        )        
    }
    render() {

    
    }
    setup_carousel() {
        document.dispatchEvent(new CustomEvent("PDPCarousel",{bubbles:true}));    
    }
}
class SurrattShippingMotivator extends CnRShippingMotivator {
  css() {
    return `
    .cnr-sm-shipping--message {
  padding: 10px 0;
  text-align: center;
  text-transform: uppercase;
  font-weight: 300;
}

.cart-num {
  letter-spacing: 0; }

.cnr-sm--bottom-text {
  text-align: center;
}

.cnr-sm-shipping--meter  {
  background: grey;
  border-radius: 20px;
  display: block;
  font-weight: bold;
  height: 20px;
  margin: 9px 0;
  padding: 0;
  position: relative;
  width: 100%; }

.cnr-sm-shipping--meter-fill {
  background: black;
  border-radius: 24px;
  color: black;
  font-size: 12px;
  height: 20px;
  left: 0;
  line-height: 20px;
  overflow: hidden;
  opacity: 1;
  padding: 0 10px;
  position: absolute;
  text-align: right;
  top: 0;
  transition: all 0.5s ease; }
    `
  }
}
class SurrattPdpPhotos extends CnRPdpPhotos {
  render() {
    
    let images = null;
    
    if (this.config.options.length==1 && this.config.options[0].values.length==1) { /* single variant product */
      images = this.images.filter(image=>!image.alt.includes("SWATCH"));
    } else {
      images = this.images.filter(img=>this.config.image_filter(img,this.config.selected))
    }
    
    let primary_images = images.map(image=>`
       <div class="single-featured-photo">
        <div class="image-fit-wrap">
			<div class="featured-image">
				<img data-src="${ image.src }"
				src="${ image.src }"
				alt="${ image.alt }"
                width="1000"
                height="auto"
				/>
		    </div>
        </div>
      </div>
    `).join("\n");
    let thumbnail_images = images.map((image,index)=>`
      <div class="single-thumb" data-image="${ image.id }" data-index="${index}" data-is-swatch="false">
        <div class="thumb-fit-wrap bg-placeholder" style="background-image:url(${image.src});">
			<img data-src="${ image.src }" src="${ image.src }" alt="${ image.alt }" width="115px" height="115px" alt="${image.alt}">
		</div>
      </div>
    `).join("\n")
    
    document.querySelector(this.config.injection_point).innerHTML = `
      <div class="single-product-photo product-photo slider-wrap">
         <div  class="js-slider-primary" id="ProductPhoto">
           ${primary_images}
        </div>
      </div>
      <div class="product-thumbs slider-wrap has-arrows pdp-carousel-slider">
        <div class="js-slider-thumbs" id="ProductThumbs">
          ${thumbnail_images}
        </div>
      </div>
    `;
    this.setup_carousel();
  }
}
